import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  QueryList,
  ViewChildren,
} from "@angular/core";
import { UtilService } from "../../shared/services/util.service";
import { ViewsService } from "../../shared/services/views.service";
import { FilterSelectComponent } from "../filter-select/filter-select.component";
import { MaterialModule } from "src/app/app.materials";
import { FormsModule, NgModel } from "@angular/forms";
import { CleanNamePipe } from "../../shared/services/clean-name.pipe";
import { ConfidenceLabelPipe } from "../../shared/services/confidence-label.pipe";
import { BenchmarkSelectorForViewsComponent } from "../benchmark-selector-for-views/benchmark-selector-for-views.component";

@Component({
  selector: "app-views-setter",
  templateUrl: "./views-setter.component.html",
  styleUrls: ["./views-setter.component.scss"],
  imports: [
    FilterSelectComponent,
    MaterialModule,
    FormsModule,
    CleanNamePipe,
    ConfidenceLabelPipe,
    BenchmarkSelectorForViewsComponent,
  ],
  standalone: true,
})
export class ViewsSetterComponent implements OnInit {
  @Input() sectors: any[] = [];
  @Input() countries: any[] = [];
  @Input() assets: any[] = [];
  @Input() benchmarks: any[] = [];
  @Input() portfolio: any;
  @Input() views: any[] = [];
  @Input() isSummary: boolean = false;
  @ViewChildren(NgModel) formControls: QueryList<NgModel>;

  activeView: any = {};
  list: any[] = [];
  formSubmitted = false;

  types = [
    { id: "asset", name: "Asset" },
    { id: "sector", name: "Sector" },
    { id: "country", name: "Country" },
    { id: "index", name: "Macro" },
  ];

  viewTypes = [
    { id: "relative", name: "Relative", disabledWithIndex: true },
    { id: "absolute", name: "Absolute", disabledWithIndex: false },
    {
      id: "relative_market_equilibrium",
      name: "Relative Market Equilibrium",
      disabledWithIndex: true,
    },
  ];

  takes = [
    { id: "outperform", name: "Outperform" },
    { id: "underperform", name: "Underperform" },
  ];

  frequencies = [
    { id: "daily", name: "Daily" },
    { id: "weekly", name: "Weekly" },
    { id: "monthly", name: "Monthly" },
    { id: "quarterly", name: "Quarterly" },
  ];

  confidenceLevels = [
    { value: 90, label: "Certain" },
    { value: 70, label: "High" },
    { value: 50, label: "Moderate" },
    { value: 30, label: "Low" },
    { value: "custom", label: "Custom" },
  ];

  confidenceSelectValue: number | "custom" = null;

  onConfidenceSelectChange(value: number | "custom") {
    if (value !== "custom") {
      this.activeView["confidence"] = value;
    } else {
      this.activeView["confidence"] = null;
    }
  }

  isFormValid(): boolean {
    const v = this.activeView;
    if (!v.type) return false;
    if (!v.items || (Array.isArray(v.items) && v.items.length === 0))
      return false;
    if (!v.view_type) return false;
    //if (!v.frequency) return false;
    if (v.value == null || v.value === "") return false;
    if (v.confidence == null || v.confidence === "") return false;
    if (
      v.view_type === "relative" &&
      (!v.items2 || (Array.isArray(v.items2) && v.items2.length === 0))
    )
      return false;
    return true;
  }

  constructor(
    private util: UtilService,
    private service: ViewsService,
  ) {}

  ngOnInit(): void {}

  onTypeChange() {
    this.list = [];
    delete this.activeView.items;
    switch (this.activeView.type) {
      case "asset":
        this.list = this.assets;
        break;
      case "sector":
        this.list = this.sectors;
        break;
      case "country":
        this.list = this.countries;
        break;
      case "index":
        this.list = this.benchmarks;
        break;
      default:
        this.list = [];
    }
  }

  onViewTypeChange() {
    if (this.activeView.view_type === "absolute") {
      delete this.activeView.take;
      delete this.activeView.items2;
    }
  }

  initActiveView() {
    return {
      type: "asset",
      portfolio_id: this.portfolio.id,
    };
  }

  onAddView() {
    this.activeView = this.initActiveView();
    this.list = this.assets;
  }

  saveView() {
    this.formSubmitted = true;
    this.formControls.forEach((c) => c.control.markAsTouched());
    if (!this.isFormValid()) {
      return;
    }

    const payload = { ...this.activeView };

    if (payload.type === "index") {
      payload.items = [payload.items.id];
    }

    this.service.create(payload).subscribe((resp) => {
      if (resp.error) {
        return this.service.notificationService.open(resp.error);
      }
      if (this.activeView.id) {
        this.views = this.util.findAndReplaceItemInArray(resp, this.views);
      } else {
        this.views.push(resp);
      }
      this.discardView();
    });
  }

  editView(c) {
    this.activeView = { ...c };
    this.activeView.type = c.type.id;

    this.onTypeChange();

    if (this.activeView.type === "index") {
      if (c.items.length > 0) {
        c.items = c.items.map((i) => {
          if (!i.name_full) {
            i.name_full = i.name; // fix benchmark selector name
          }
          return i;
        });
      }
      this.activeView.items = c.items[0];
    } else {
      this.activeView.items = c.items.map((i) => +i.id);
    }
    this.activeView.items2 = c.items2.map((i) => +i.id);
    this.activeView.portfolio_id = this.portfolio.id;

    const presetValues = [90, 70, 50, 30];
    this.confidenceSelectValue = presetValues.includes(c.confidence)
      ? c.confidence
      : "custom";
  }

  deleteView(v) {
    this.service.delete(v).subscribe((resp) => {
      this.views = this.views.filter((viw) => viw.id !== v.id);
    });
  }

  discardView() {
    this.activeView = {};
    this.confidenceSelectValue = null;
    this.formSubmitted = false;
  }
}
